function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("pattern", {
  id: "pid-0.4344735749337849",
  x: 0,
  y: 0,
  width: 163.84,
  height: 163.84,
  patternUnits: "userSpaceOnUse"
}, React.createElement("g", {
  transform: "scale(0.64)"
}, React.createElement("g", {
  transform: "translate(-220.138 220.138)"
}, React.createElement("line", {
  x1: 28.71888535554777,
  x2: 1.0033210854274728,
  y1: 12.219418016451954,
  y2: 39.93498228657225,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 28.71888535554777,
  x2: 1.0033210854274728,
  y1: -499.780581983548,
  y2: -472.0650177134278,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 284.71888535554774,
  x2: 257.0033210854275,
  y1: -499.780581983548,
  y2: -472.0650177134278,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 540.7188853555477,
  x2: 513.0033210854275,
  y1: -499.780581983548,
  y2: -472.0650177134278,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 28.71888535554777,
  x2: 1.0033210854274728,
  y1: -243.78058198354805,
  y2: -216.06501771342775,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 284.71888535554774,
  x2: 257.0033210854275,
  y1: -243.78058198354805,
  y2: -216.06501771342775,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 540.7188853555477,
  x2: 513.0033210854275,
  y1: -243.78058198354805,
  y2: -216.06501771342775,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 28.71888535554777,
  x2: 1.0033210854274728,
  y1: 12.219418016451954,
  y2: 39.93498228657225,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 284.71888535554774,
  x2: 257.0033210854275,
  y1: 12.219418016451954,
  y2: 39.93498228657225,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 540.7188853555477,
  x2: 513.0033210854275,
  y1: 12.219418016451954,
  y2: 39.93498228657225,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 191.55152674898414,
  x2: 180.32652409229632,
  y1: 190.8662965067184,
  y2: 202.09129916340623,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 191.55152674898414,
  x2: 180.32652409229632,
  y1: -321.1337034932816,
  y2: -309.90870083659377,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 447.55152674898414,
  x2: 436.3265240922963,
  y1: -321.1337034932816,
  y2: -309.90870083659377,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 703.5515267489841,
  x2: 692.3265240922963,
  y1: -321.1337034932816,
  y2: -309.90870083659377,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 191.55152674898414,
  x2: 180.32652409229632,
  y1: -65.13370349328159,
  y2: -53.908700836593766,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 447.55152674898414,
  x2: 436.3265240922963,
  y1: -65.13370349328159,
  y2: -53.908700836593766,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 703.5515267489841,
  x2: 692.3265240922963,
  y1: -65.13370349328159,
  y2: -53.908700836593766,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 191.55152674898414,
  x2: 180.32652409229632,
  y1: 190.8662965067184,
  y2: 202.09129916340623,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 447.55152674898414,
  x2: 436.3265240922963,
  y1: 190.8662965067184,
  y2: 202.09129916340623,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 703.5515267489841,
  x2: 692.3265240922963,
  y1: 190.8662965067184,
  y2: 202.09129916340623,
  strokeWidth: 5,
  stroke: "#68d5b8",
  strokeLinecap: "round"
}), React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  values: "0 0;-256 256",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  dur: "2.5s"
})), React.createElement("g", {
  transform: "translate(-74.2073 74.2073)"
}, React.createElement("line", {
  x1: 263.3019659434364,
  x2: 238.96593799043282,
  y1: 58.1374418935296,
  y2: 82.47346984653316,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 263.3019659434364,
  x2: 238.96593799043282,
  y1: -453.8625581064704,
  y2: -429.52653015346687,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 519.3019659434365,
  x2: 494.96593799043285,
  y1: -453.8625581064704,
  y2: -429.52653015346687,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 775.3019659434365,
  x2: 750.9659379904328,
  y1: -453.8625581064704,
  y2: -429.52653015346687,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 263.3019659434364,
  x2: 238.96593799043282,
  y1: -197.8625581064704,
  y2: -173.52653015346684,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 519.3019659434365,
  x2: 494.96593799043285,
  y1: -197.8625581064704,
  y2: -173.52653015346684,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 775.3019659434365,
  x2: 750.9659379904328,
  y1: -197.8625581064704,
  y2: -173.52653015346684,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 263.3019659434364,
  x2: 238.96593799043282,
  y1: 58.1374418935296,
  y2: 82.47346984653316,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 519.3019659434365,
  x2: 494.96593799043285,
  y1: 58.1374418935296,
  y2: 82.47346984653316,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 775.3019659434365,
  x2: 750.9659379904328,
  y1: 58.1374418935296,
  y2: 82.47346984653316,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 7.301965943436414,
  x2: -17.03406200956718,
  y1: 58.1374418935296,
  y2: 82.47346984653316,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 115.07101062231165,
  x2: 83.92695261255345,
  y1: 226.8398410559897,
  y2: 257.9838990657479,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 115.07101062231165,
  x2: 83.92695261255345,
  y1: -285.1601589440103,
  y2: -254.0161009342521,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 371.07101062231163,
  x2: 339.92695261255346,
  y1: -285.1601589440103,
  y2: -254.0161009342521,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 627.0710106223116,
  x2: 595.9269526125535,
  y1: -285.1601589440103,
  y2: -254.0161009342521,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 115.07101062231165,
  x2: 83.92695261255345,
  y1: -29.160158944010306,
  y2: 1.9838990657478917,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 371.07101062231163,
  x2: 339.92695261255346,
  y1: -29.160158944010306,
  y2: 1.9838990657478917,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 627.0710106223116,
  x2: 595.9269526125535,
  y1: -29.160158944010306,
  y2: 1.9838990657478917,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 115.07101062231165,
  x2: 83.92695261255345,
  y1: 226.8398410559897,
  y2: 257.9838990657479,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 371.07101062231163,
  x2: 339.92695261255346,
  y1: 226.8398410559897,
  y2: 257.9838990657479,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 627.0710106223116,
  x2: 595.9269526125535,
  y1: 226.8398410559897,
  y2: 257.9838990657479,
  strokeWidth: 5,
  stroke: "#a9f0f9",
  strokeLinecap: "round"
}), React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  values: "0 0;-256 256",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s"
})))));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  fill: "url(#pid-0.4344735749337849)"
});

var SvgBcgPattern = function SvgBcgPattern(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      display: "block"
    },
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1084 100%",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBcgPattern, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bcg-pattern.6c32bcef.svg";
export { ForwardRef as ReactComponent };